import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { StyledRgrl } from "../../../styled/Prevencion";
import GremialistasTable from "./GremialistasTable";

const GremialistasContainer = ({ nextForm }) => {
  const gremialistas = useSelector((state) => state.rgrl.postRgrl.gremialistas);

  const handleSubmit = () => {
    nextForm("Contratistas");
  };

  return (
    <>
      <GremialistasTable data={gremialistas} handleSubmit={handleSubmit} />
      <StyledRgrl.ButtonContainer style={{ marginTop: "20px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          Siguiente
        </Button>
      </StyledRgrl.ButtonContainer>

    </>

  );
};
export default GremialistasContainer;
